//      
                                                    
import cartReducer from "./cartReducer";
                                                        
import configReducer from "./configReducer";
                                                          
import contentReducer from "./contentReducer";
                                                        
import filterReducer from "./filterReducer";
                                                          
import consentReducer from "./consentReducer";

                                
                        
                            
                              
                            
                              
 

                             
              
             
  

export const rootReducer                   = {
	cart: cartReducer,
	config: configReducer,
	content: contentReducer,
	filter: filterReducer,
	consent: consentReducer,
};
